<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<app-new-impact-measurement [isCovariatesAnalysis]="true" [submitButtonDisabled]="isLoading()"
    (onCovariatesAnalysisStarted)="storeTaskAndStartWorker($event)"/>
<div class="view-covariates-results" *ngIf="task">
  <mat-divider/>
  <br>
  <h2>Covariates Analysis Results</h2>
  <ng-container *ngIf="isTaskRunning(); else noSpinner">
    <mat-spinner color="accent" [diameter]="spinnerDiameter" class="pending-results-splinner">
    </mat-spinner>
  </ng-container>
  <ng-template #noSpinner>
    <ng-container *ngIf="isCompleted(); else cancelledOrFailed">
      <app-causal-impact-results
          *ngIf="task.taskResult
          && extractCausalImpactResult().causal_impact_summaries?.length"
          [causalImpactResults]="extractCausalImpactResult()" [experimentId]="'0000'"
          [testGroups]="extractCausalImpactAnalysisParameters().test_groups"
          [isCovariatesAnalysis]="true"/>
    </ng-container>
    <ng-template #cancelledOrFailed>
      <mat-card class="view-experiment-field">
        <mat-card-header class="view-exp-card-content" >
          <mat-card-title-group>
            <mat-card-title>Error Details</mat-card-title>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          <mat-card class="view-exp-file-field">
            <mat-card-header class="error-message-header">
              <mat-card-title-group>
                <mat-card-subtitle i18n>Error Message</mat-card-subtitle>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <p class="error-message">{{displayErrorMessage()}}</p>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </ng-template>
</div>